// import * as firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/firestore";
// import "firebase/storage";

// Import only what you need from the modular SDK
import { initializeApp, getApps, getApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  connectFirestoreEmulator,
  getFirestore,
  serverTimestamp,
} from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const API_KEY = `${process.env.REACT_APP_FIREBASE_API_KEY}`;
const MESSAGE_ID = `${process.env.REACT_APP_FIREBASE_MESSAGING_ID}`;
const APP_ID = `${process.env.REACT_APP_FIREBASE_APP_ID}`;
const STORAGE = `${process.env.REACT_APP_STORAGE}`;
const DOMAIN = `${process.env.REACT_APP_AUTH_DOMAIN}`;
const PROJECT_ID = `${process.env.REACT_APP_PROJECT_ID}`;
const DATABASE = `${process.env.REACT_APP_DATABASE}`;

const config = {
  apiKey: API_KEY,
  authDomain: DOMAIN,
  databaseURL: DATABASE,
  projectId: PROJECT_ID,
  storageBucket: STORAGE,
  messagingSenderId: MESSAGE_ID,
  appId: APP_ID,
};

// if (!firebase.apps.length) {
//   firebase.initializeApp(config);
// }

// Initialize (or reuse) the Firebase App
const app = !getApps().length ? initializeApp(config) : getApp();

// const Auth = firebase.auth();
// const Firestore = firebase.firestore();
// const Storage = firebase.storage().ref("images");
// const Firebase = firebase;
// const SetTime = firebase.firestore.FieldValue.serverTimestamp();

// export { Auth, Firestore, Storage, Firebase, SetTime };

// Export the individual services you need
const Auth = getAuth(app);
const Firestore = getFirestore(app);
const Storage = getStorage(app);
const Firebase = app;
const SetTime = serverTimestamp();

if (process.env.REACT_APP_USE_EMULATORS === "true") {
  const host = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  connectAuthEmulator(Auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(Firestore, host, 8080);
  connectStorageEmulator(Storage, host, 9199);
}

export { app, Auth, Firestore, Storage, Firebase, SetTime };
